export const getCurrentLocaleCode = (routerLocale?: string) => {
  const locales: ['en', 'lt'] = ['en', 'lt']

  const locale = locales.find((l) => l === routerLocale)

  return locale ?? 'en'
}
